<template>
    <sidebar-tab>
        <form-row>
            <form-field>
                <div class="tw-flex tw-items-center tw-select-none tw-mt-3">
                    <div class="trophy trophy-picker-preview tw-cursor-pointer" :style="[{ background: trophy.background }, { borderColor: trophy.border }, { color: trophy.color }]">
                        <template v-if="trophy.uploads.length > 0">
                            <img :src="trophy.uploads[0].url">
                        </template>
                        <i v-else :class="trophy.icon"></i>
                    </div>
                    <p class="tw-flex-1 tw-text-sm tw-text-gray-700 tw-ml-3 tw-mr-2">
                        {{ $t('events.receive') }} <b>{{ trophy.title }}</b> {{ $t('events.when_you_join') }} {{ $t('events.singular').toLowerCase() }}
                    </p>
                </div>
            </form-field>
        </form-row>
    </sidebar-tab>
</template>

<script>
    import Global from '../../../mixins/Global';

    export default {
        name: 'EventsSidebarTrophy',

        mixins: [Global],

        props: {
            trophy: {
                required: true,
            },
        },
    };
</script>
